import thunk from 'redux-thunk';
import { applyMiddleware, compose, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { persistReducer, persistStore } from 'redux-persist';
import storageSession from "redux-persist/lib/storage/session";

import { rootReducer } from './../modules';

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

const persistConfig = {
  key: "root",
  storage: storageSession,
  whitelist: ["user"], // Add reducers you want to persist (e.g., auth, cart)
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const middlewares = [thunk];
const middlewareEnhancer = applyMiddleware(...middlewares)

const enhancers = [middlewareEnhancer];
const composedEnhancers = composeWithDevTools(...enhancers)

const store = createStore(persistedReducer, undefined, composedEnhancers);
const persistor = persistStore(store);

export { store, persistor };
